import { render, staticRenderFns } from "./SinisterActions.vue?vue&type=template&id=010368c4&scoped=true"
import script from "./SinisterActions.vue?vue&type=script&lang=ts"
export * from "./SinisterActions.vue?vue&type=script&lang=ts"
import style0 from "./SinisterActions.vue?vue&type=style&index=0&id=010368c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010368c4",
  null
  
)

export default component.exports